<!-- Navigation Header -->
<header class="bills-header-nav">
  <div class="nav-content">
    <div class="nav-left">
      <button class="back-btn" (click)="goBack()">
        <i class="pi pi-arrow-left"></i>
        <span>Back to Store</span>
      </button>
      <h1 class="page-title">Bills Payment</h1>
    </div>
  </div>
</header>

<div class="bills-payment-container" [class.faded]="showPurchaseModal()">
  <!-- Not Logged In State -->
  @if (!isLoggedIn()) {
    <div class="not-logged-in">
      <div class="empty-state">
        <div class="empty-icon">
          <i class="pi pi-money-bill" style="font-size: 2.5rem;"></i>
        </div>
        <h2>Bills Payment Service</h2>
        <p>Please log in to pay your bills - Airtime, Data, Cable TV, and Electricity</p>
        
        <div class="auth-buttons">
          <button type="button" pButton label="Sign In" (click)="goToSignIn()" class="p-button-primary"></button>
        </div>
      </div>
    </div>
  }

  <!-- Logged In State -->
  @if (isLoggedIn()) {
    <div class="bills-content">
      <!-- Page Header -->
      <div class="page-header">
        <h1 class="main-title">Pay Your Bills</h1>
        <p class="subtitle">Choose a service to get started</p>
      </div>

      <!-- Loading State -->
      @if (isLoading()) {
        <div class="loading-state">
          <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
          <p>Loading services...</p>
        </div>
      }

      <!-- Bill Type Cards Grid -->
      @if (!isLoading()) {
        <div class="bill-types-grid">
          @for (billType of billTypes; track billType.id) {
            <div class="bill-type-card" 
                 [ngClass]="'bill-type-' + billType.color"
                 (click)="openPurchaseModal(billType)">
              <div class="card-icon">
                @if (billType.icon === 'phone') {
                  <i class="pi pi-phone" style="font-size: 3rem;"></i>
                } @else if (billType.icon === 'wifi') {
                  <i class="pi pi-wifi" style="font-size: 3rem;"></i>
                } @else if (billType.icon === 'tv') {
                  <i class="pi pi-desktop" style="font-size: 3rem;"></i>
                } @else if (billType.icon === 'bolt') {
                  <i class="pi pi-bolt" style="font-size: 3rem;"></i>
                }
              </div>
              
              <div class="card-content">
                <h3 class="card-title">{{ billType.name }}</h3>
                <p class="card-description">{{ billType.description }}</p>
              </div>
              
              <div class="card-action">
                <button type="button" pButton label="Get Started" class="p-button-primary" (click)="openPurchaseModal(billType); $event.stopPropagation()"></button>
              </div>
            </div>
          }
        </div>
      }

      <!-- Info Section -->
      <div class="info-section">
        <div class="info-card">
          <div class="info-icon">
            <i class="pi pi-check-circle" style="font-size: 1.5rem;"></i>
          </div>
          <div class="info-content">
            <h4>Quick & Easy</h4>
            <p>Pay your bills instantly with your shopping card balance</p>
          </div>
        </div>
        
        <div class="info-card">
          <div class="info-icon">
            <i class="pi pi-shield" style="font-size: 1.5rem;"></i>
          </div>
          <div class="info-content">
            <h4>Secure Payments</h4>
            <p>All transactions are encrypted and secure</p>
          </div>
        </div>
        
        <div class="info-card">
          <div class="info-icon">
            <i class="pi pi-send" style="font-size: 1.5rem;"></i>
          </div>
          <div class="info-content">
            <h4>Instant Delivery</h4>
            <p>Get your airtime, data, or tokens immediately</p>
          </div>
        </div>
      </div>
    </div>
  }
</div>

<!-- Purchase Modal -->
@if (selectedBillType()) {
  <app-bills-purchase-modal
    [billType]="selectedBillType()!"
    [airtimeServices]="airtimeServices()"
    [dataServices]="dataServices()"
    [cableServices]="cableServices()"
    [electricityServices]="electricityServices()"
    [platformId]="platformId()"
    [(visible)]="showPurchaseModal"
    (success)="onPurchaseSuccess()"
  ></app-bills-purchase-modal>
}

<p-toast position="bottom-right"></p-toast>
